// useTableFilterStore.ts

import { create } from 'zustand'
import { selectValueType } from '@/shared/components/DynamicForm/DynamicForm'
import { OptionType } from '@/shared/api/BaseAPI.model'
import { FILTER_KEYS, TABLE_KEYS } from '../models/Filter.model'

type FilterValues = {
  [FILTER_KEYS.CATEGORIES_FILTER]: OptionType[]
  [FILTER_KEYS.MENU_TYPE_FILTER]: OptionType[]
  [FILTER_KEYS.DISH_SIZE_FILTER]: OptionType[]
  [FILTER_KEYS.ALLERGENS_FILTER]: OptionType[]
  [FILTER_KEYS.LANGUANGE_FILTER]: OptionType | null
}

type TableFilterState = {
  filters: Partial<Record<TABLE_KEYS, Partial<FilterValues>>>
  setFilter: (
    table: TABLE_KEYS,
    key: FILTER_KEYS,
    value: selectValueType
  ) => void
  resetFilters: (
    table: TABLE_KEYS,
    defaultLanguageOption: OptionType | null
  ) => void
}

const emptyFilters: FilterValues = {
  [FILTER_KEYS.CATEGORIES_FILTER]: [],
  [FILTER_KEYS.MENU_TYPE_FILTER]: [],
  [FILTER_KEYS.DISH_SIZE_FILTER]: [],
  [FILTER_KEYS.ALLERGENS_FILTER]: [],
  [FILTER_KEYS.LANGUANGE_FILTER]: null
}

export const useTableFilterStore = create<TableFilterState>(set => ({
  filters: {},

  setFilter: (table, key, value) =>
    set(state => ({
      filters: {
        ...state.filters,
        [table]: {
          ...(state.filters[table] ?? emptyFilters),
          [key]: value
        }
      }
    })),

  resetFilters: (table, defaultLanguageOption) =>
    set(state => ({
      filters: {
        ...state.filters,
        [table]: {
          ...emptyFilters,
          [FILTER_KEYS.LANGUANGE_FILTER]: defaultLanguageOption
        }
      }
    }))
}))
